import { SourceBasedExpression } from './Expression.js';
export class OclIsUndefinedExpression extends SourceBasedExpression {
    evaluate(visitor, localVariables) {
        const result = this.getSource()
            .evaluate(visitor, localVariables);
        return !Boolean(result) || typeof result === 'undefined';
    }
}
//# sourceMappingURL=OclIsUndefinedExpression.js.map